import { h } from "@stencil/core";
import { TableDataCell } from "../table-data-cell/table-data-cell";
import { TableDataHeader } from "../table-data-header/table-data-header";
export class TableDataColumn {
    constructor() {
        this.field = undefined;
        this.label = undefined;
        this.group = false;
        this.sortable = false;
        this.sortField = undefined;
        this.multiline = false;
    }
    /** make the render function public */
    async getColumnMethods() {
        const { renderHeader, renderCell, getSortString } = this;
        return {
            renderHeader,
            renderCell,
            getSortString
        };
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    getSortString = (row) => {
        const sortField = this.sortField || this.field;
        if (sortField === "" || !row[sortField]) {
            return "";
        }
        return row[sortField] + "";
    };
    renderHeader = () => {
        return (h(TableDataHeader, { label: this.label, sortable: this.sortable, sortField: this.sortField || this.field, group: this.group }));
    };
    /** render the cell for the column */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    renderCell = (row) => {
        const { field, group, multiline } = this;
        const empty = field === "" || !row[field];
        return (h(TableDataCell, { group: group, empty: empty, multiline: multiline }, h("span", null, !empty && row[field])));
    };
    static get is() { return "ux-table-data-column"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-data-column.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-data-column.css"]
        };
    }
    static get properties() {
        return {
            "field": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "defines which field of the table will be displayed in the column"
                },
                "attribute": "field",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "defines the label of the table column"
                },
                "attribute": "label",
                "reflect": false
            },
            "group": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "defines if the column should be a group"
                },
                "attribute": "group",
                "reflect": false,
                "defaultValue": "false"
            },
            "sortable": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "defines if the column should be sortable"
                },
                "attribute": "sortable",
                "reflect": false,
                "defaultValue": "false"
            },
            "sortField": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "defines the sort field name, if set, instead of using the column field"
                },
                "attribute": "sort-field",
                "reflect": false
            },
            "multiline": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "wrap the content of this column if required, requires to set a max-width on table\n(e.g. using `full-width` or css prop `--ux-table-data-width`) or column"
                },
                "attribute": "multiline",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get methods() {
        return {
            "getColumnMethods": {
                "complexType": {
                    "signature": "() => Promise<{ renderHeader: () => any; renderCell: (row: any) => any; getSortString: (row: any) => string; }>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<{ renderHeader: () => any; renderCell: (row: any) => any; getSortString: (row: any) => string; }>"
                },
                "docs": {
                    "text": "make the render function public",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=table-data-column.js.map
